import * as React from "react";
import { useSessionTracking } from "../hooks/useSessionTracking";

/**
 * Component that enables automatic session tracking
 * Should be placed inside all context providers
 */
export const SessionTracker: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Enable session tracking
  useSessionTracking();
  
  // This component doesn't render anything visible, just enables tracking
  return <>{children}</>;
};